<div class="mc-size-disclaimer" *ngIf="showDisclaimer">
	<div class="mc-size-disclaimer__text">
		{{ 'disclaimer.text' | translate }}
	</div>
	<button class="mc-size-disclaimer__close" (click)="onClose()">x</button>
</div>
